/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'svg-gear-b-internal': {
    width: 28,
    height: 28,
    viewBox: '-3.205 -3.205 28 28',
    data: '<path pid="0" d="M10.794-3.205c-7.731 0-14 6.268-14 14 0 7.731 6.269 14 14 14 7.732 0 14-6.269 14-14 0-7.732-6.268-14-14-14zM9.56.226h2.37c.16 0 1.325 2.9 1.325 2.9l1.32.534s2.863-1.307 2.98-1.194l1.679 1.639c.112.11-1.156 2.97-1.156 2.97l.545 1.296s2.967 1.054 2.966 1.215v2.32c0 .156-2.962 1.299-2.962 1.299l-.545 1.293s1.337 2.8 1.22 2.916l-1.677 1.64c-.113.11-3.03-1.133-3.03-1.133l-1.322.536s-1.08 2.906-1.244 2.906h-2.37c-.16 0-1.325-2.899-1.325-2.899L7.01 17.93s-2.862 1.307-2.976 1.196l-1.678-1.643c-.111-.11 1.156-2.969 1.156-2.969l-.545-1.29S0 12.164 0 12.002V9.681c0-.154 2.962-1.295 2.962-1.295l.545-1.293S2.173 4.29 2.29 4.177l1.675-1.64C4.076 2.426 7 3.667 7 3.667l1.318-.535S9.395.226 9.56.226z"/>'
  }
})
